import { render, staticRenderFns } from "./DnfgMore.vue?vue&type=template&id=6c6fe0cc&scoped=true"
import script from "./DnfgMore.vue?vue&type=script&lang=js"
export * from "./DnfgMore.vue?vue&type=script&lang=js"
import style0 from "./DnfgMore.vue?vue&type=style&index=0&id=6c6fe0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fe0cc",
  null
  
)

export default component.exports